import { CustomerStoryFilterObject } from '.';

export const defaultCustomerStoryFilterOptionsObject = {
	solution: {
		// solution filters are loaded from Content Platform
	},
	product: {
		// product filters are loaded from Content Platform
	},
	industry: {
		// industry filters are loaded from Content Platform
	},
	'more filters': {
		'Marketplace apps': {
			committedActive: false,
			stagedActive: false,
			description: 'Only show stories from customers that use marketplace apps',
		},
		'Solution partner': {
			committedActive: false,
			stagedActive: false,
			description: 'Only show stories from customers that have a solution partner',
		},
		// region & team size filters are loaded from Content Platform
	},
} as const satisfies CustomerStoryFilterObject;
